var exports = {
  "j": "TabNav__A6nIZB",
};

module.exports = exports;
